'use strict'

import { COOKIE_ACCESS_TOKEN } from '@/constants'
import { EC_LINE031 } from '@/constants/route-page'
import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import Cookies from 'js-cookie'
import store from '@/store'
import { trimForm } from '@/utils'
import { ENV_KEY } from '@/constants/env'
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const requestConfigFunction = (config) => {
  const arrayFormat = 'repeat'

  config.paramsSerializer = (params) => qs.stringify(params, { arrayFormat })
  config.transformRequest = [(data) => trimForm(data, ['delivery_notes']), ...axios.defaults.transformRequest]
  const accessToken = Cookies.get(COOKIE_ACCESS_TOKEN)

  if (!config.url.startsWith('http') && accessToken) {
    config.headers.common.Authorization = `Bearer ${accessToken}`
  }

  config.headers.common['accept-language'] = 'ja'

  const shop_id = store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID)
  const client_id = store.getters['env/GET_KEY'](ENV_KEY.CLIENT_ID)
  shop_id && (config.headers.common['x-shop-id'] = shop_id)
  client_id && (config.headers.common['x-client-id'] = client_id)

  return config
}
const requestErrorFunction = [(error) => Promise.reject(error)]

const responseConfigFunction = (response) => response.data
const responseErrorFunction = async (error) => {
  if (error.response.status === 401) {
    await store.dispatch('auth/removeAuth')
    router.push(EC_LINE031)
  }

  return Promise.reject(error)
}
const downloadResponseConfigFunction = (response) => response

const commonConfig = {
  baseURL: process.env.VUE_APP_COMMON_API,
}

const clientConfig = {
  baseURL: process.env.VUE_APP_CLIENT_API,
}

const postCodeJpConfig = {
  baseURL: process.env.VUE_APP_POST_CODE_JP_API,
}

const commonAxios = axios.create(commonConfig)
const clientAxios = axios.create(clientConfig)
const postCodeAxios = axios.create(postCodeJpConfig)
const downloadAxios = axios.create(clientConfig)

commonAxios.interceptors.request.use(requestConfigFunction, requestErrorFunction)
commonAxios.interceptors.response.use(responseConfigFunction, responseErrorFunction)
clientAxios.interceptors.request.use(requestConfigFunction, requestErrorFunction)
clientAxios.interceptors.response.use(responseConfigFunction, responseErrorFunction)
downloadAxios.interceptors.request.use(requestConfigFunction, requestErrorFunction)
downloadAxios.interceptors.response.use(downloadResponseConfigFunction, responseErrorFunction)

export { commonAxios, clientAxios, postCodeAxios, downloadAxios }
